import { render, staticRenderFns } from "./SimpleGallery.vue?vue&type=template&id=3799cc3c&scoped=true&"
import script from "./SimpleGallery.vue?vue&type=script&lang=js&"
export * from "./SimpleGallery.vue?vue&type=script&lang=js&"
import style0 from "./SimpleGallery.vue?vue&type=style&index=0&id=3799cc3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3799cc3c",
  null
  
)

export default component.exports